/* global axios */

import ApiClient from './ApiClient';

class UserEventTypesAPI extends ApiClient {
  constructor() {
    super('user_event_types', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  fetchEventDetails(eventId) {
    return axios.get(`${this.url}/fetch_event_details`, {
      params: { event_id: eventId },
    });
  }

  sync() {
    return axios.post(`${this.url}/sync`);
  }

  getAvailabilitySlots({
    eventId,
    scheduleId,
    month,
    year,
    timeZone,
    contactEmail,
  }) {
    return axios.get(`${this.url}/availability_slots`, {
      params: {
        event_id: eventId,
        schedule_id: scheduleId,
        month,
        year,
        time_zone: timeZone,
        contact_email: contactEmail,
      },
    });
  }

  bookAppointment(data) {
    return axios.post(`${this.url}/book_appointment`, data);
  }

  rescheduleAppointment(data) {
    return axios.patch(`${this.url}/reschedule_appointment`, data);
  }
}

export default new UserEventTypesAPI();
